import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeEditorComponent } from './tree-editor/tree-editor.component';
import { DataAccessModule } from '../data-access/data-access.module';
import { SharedModule } from '../shared/shared.module';
import { AgGridModule } from '@ag-grid-community/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { MethodsEditorComponent } from './methods-editor/methods-editor.component';
import { GridModule } from '../grid/grid.module';
import {
  MatTreeModule,
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatExpansionModule,
  MatChipsModule,
} from '@angular/material';



@NgModule({
  declarations: [TreeEditorComponent, MethodsEditorComponent],
  imports: [
    CommonModule,
    DataAccessModule,
    GridModule,
    MatTreeModule,
    SharedModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    AgGridModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatChipsModule,
  ],

  entryComponents: [TreeEditorComponent, MethodsEditorComponent],
})

export class PredefinedFormsModule { }
